{
	"message": "Found the below photos which are larger than 100 megapixels. Due to memory constraints, exported or intermediate photos may be corrupted.",
	"title": "Warning: Found photos larger than 100 megapixels"
}
